<template>
  <ts-loading-banner :loading="update_imei_loading">
    <div class="row">
      <div class="col-md-12 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.serial#') }}</label>
        <input
          type="text"
          v-model="model.serial_no"
          class="form-control"
          readonly
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group">
        <label class="ts-text-xs required">{{
          $t('productProfile.cowTag')
        }}</label>
        <input type="text" v-model.trim="model.imei" class="form-control" />
        <div class="validate" v-if="errors.has('imei')">
          {{ errors.first('imei') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="ts-text-xs required">{{
            $t('productProfile.sex')
          }}</label>
          <select v-model="model.sex" class="form-control">
            <option value="F">Female</option>
            <option value="M">Male</option>
          </select>
          <div class="validate" v-if="errors.has('sex')">
            {{ errors.first('sex') }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="ts-text-xs required">{{
            $t('productProfile.color')
          }}</label>
          <Select
            class="ts-w-full"
            v-model="model.color"
            filterable
            allow-create
            @on-create="handleCreate"
          >
            <Option
              v-for="(item, index) in colors"
              :value="item.color"
              :key="index"
              >{{ item.color }}</Option
            >
          </Select>
          <div class="validate" v-if="errors.has('color')">
            {{ errors.first('color') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.weight') }}</label>
        <input type="text" v-model.number="model.weight" class="form-control" />
        <div class="validate" v-if="errors.has('weight')">
          {{ errors.first('weight') }}
        </div>
      </div>
      <div class="col-md-6 form-group">
        <label class="ts-text-xs required">{{
          $t('productProfile.cost')
        }}</label>
        <input type="text" v-model.number="model.cost" class="form-control" />
        <div class="validate" v-if="errors.has('cost')">
          {{ errors.first('cost') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.remark') }}</label>
        <textarea
          rows="3"
          class="form-control"
          v-model="model.qc_remarks"
        ></textarea>
        <div class="validate" v-if="errors.has('qc_remarks')">
          {{ errors.first('qc_remarks') }}
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'CarUpdateSerial',
  props: [
    'value',
    'show_modal_update_imei_serial',
    'waiting_update',
    'update_imei_loading'
  ],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  computed: {
    ...mapState('product/profile', ['colors'])
  },
  created() {
    this.model = this.value
  },
  methods: {
    handleCreate(val) {
      this.colors.push({
        value: val,
        color: val
      })
    }
  }
}
</script>
